import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotificationPage } from './notification.page';
import { NotificacoesDetalhesPage } from './pages/notificacoes-detalhes/notificacoes-detalhes.page';

const routes: Routes = [
  {
    path: '',
    component: NotificationPage,
  },
  {
    path: ':notificacaoId',
    component: NotificacoesDetalhesPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NotificationPageRoutingModule { }
